;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import type { ButtonProps } from "@mui/material/Button"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_YELLOW_COLOR_BUTTON,
  UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED,
  UI_STYLE_BLACK_COLOR_BUTTON,
  UI_STYLE_BLACK_COLOR_BUTTON_PUSHED,
  UI_STYLE_PRIMARY_FONT,
} from "../../../../../lib/constants"
import { YELLOW_COLOR } from "../constants"

import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"

const YellowButton = styled(Button)(({ theme }) => ({
  color: UI_STYLE_PRIMARY_BLUE_BLACK,
  backgroundColor: UI_STYLE_YELLOW_COLOR_BUTTON,
  boxShadow: "none",
  width: "188px",
  height: "52px",
  filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
  fontFamily: UI_STYLE_PRIMARY_FONT,
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "19px",
  textTransform: "unset",
  textAlign: "center",
  letterSpacing: "0.03em",
  borderRadius: "100px",
  "@media only screen and (min-width: 600px)": {
    fontSize: "18px",
    width: "213px",
  },
  "&:hover": {
    backgroundColor: UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED,
  },
}))

const BlackButton = styled(Button)(({ theme }) => ({
  color: "white",
  backgroundColor: UI_STYLE_BLACK_COLOR_BUTTON,
  boxShadow: "none",
  width: "188px",
  height: "52px",
  filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
  fontFamily: UI_STYLE_PRIMARY_FONT,
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "19px",
  textAlign: "center",
  textTransform: "unset",
  letterSpacing: "0.03em",
  borderRadius: "100px",
  "@media only screen and (min-width: 600px)": {
    fontSize: "18px",
    width: "213px",
  },
  "&:hover": {
    backgroundColor: UI_STYLE_BLACK_COLOR_BUTTON_PUSHED,
  },
}))

type PrimaryButtonProps = {
  color: string
  text: string
  href?: ButtonProps["href"]
  onClick?: ButtonProps["onClick"]
}

function PrimaryButton({ color, onClick, href, text }: PrimaryButtonProps) {
  if (color == YELLOW_COLOR) {
    return (
      <YellowButton variant="contained" href={href} onClick={onClick}>
        {text}
      </YellowButton>
    )
  }
  return (
    <BlackButton variant="contained" href={href} onClick={onClick}>
      {text}
    </BlackButton>
  )
}

export default PrimaryButton
